module.exports = __webpack_public_path__ + "img/MED_CHEESE@300x.bd20c873.png";